'use strict';
import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import fetch from './fetch';

Vue.use(VueAxios, axios);

const getFetch = (url, data) => {
  return new Promise((resolve, reject) => {
    fetch({url: url, method: 'get', params: data}).then(res => {
      resolve(res)
    }).catch(err => {
      console.log(err);
    })
  })
};

const postFetchBody = (url, data, file, loading) => {
  return new Promise((resovle, reject) => {

    if (file) {
      let option = {url: url, method: 'post', data, headers: {'Content-Type': 'multipart/form-data'}};
      fetch(option).then(res => {
        resovle(res);
      }).catch(err => {
        console.log(err);
      })

    } else {

      let option = {url: url, method: 'post', data, headers: {'loading': loading}};
      fetch(option).then(res => {
        resovle(res);
      }).catch(err => {
        console.log(err);
      })
    }
  })
};

const postFetchParams = (url, data) => {
  return new Promise((resolve, reject) => {
    fetch({url: url, method: 'post', params: data}).then(res => {
      resolve(res)
    }).catch(err => {
      console.log(err);
    })
  })
};

export {getFetch, postFetchBody, postFetchParams}



// WEBPACK FOOTER //
// ./src/utils/getData.js